import Parser from "html-react-parser";

const parseTruncate = (text: string | undefined, maxLength: number, cutoffText?: string) => {
  maxLength = Math.floor(maxLength);

  if (maxLength <= 0 || !text) {
    return null;
  }

  const truncatedHtml = truncate(text, maxLength, cutoffText);

  return Parser(truncatedHtml);
};

export default parseTruncate;

function truncate(htmlText: string, maxLength: number, cutoffText?: string) {
  const helperNode = document.createElement("div");
  helperNode.innerHTML = htmlText.trim();

  truncateNode(helperNode, maxLength, cutoffText);

  return helperNode.innerHTML.trim();
}

const lastCharRegexp = /[., ]/;
const stopChars = [" ", ",", "."];

function truncateNode(node: Node, remainingLength: number, cutoffText?: string) {
  let isEmpty = true;

  const nodesToCheck: Node[] = Array.prototype.slice.call(node.childNodes);

  for (const child of nodesToCheck) {
    if (child.nodeName.toLowerCase() === "#text") {
      const result = truncateText(child.textContent || "", remainingLength, cutoffText);
      remainingLength = result.remaining;
      if (result.isEmpty) {
        child.parentElement!.removeChild(child);
      } else {
        child.textContent = result.text;
        isEmpty = false;
      }
    } else {
      const result = truncateNode(child, remainingLength, cutoffText);
      remainingLength = result.remaining;
      if (result.isEmpty) {
        child.parentElement!.removeChild(child);
      } else {
        isEmpty = false;
      }
    }
  }

  return {
    isEmpty,
    remaining: remainingLength,
  };
}

function truncateText(text: string, maxLength: number, cutoffText?: string) {
  if (text.length <= maxLength) {
    return {
      text,
      isEmpty: text.length === 0,
      remaining: maxLength - text.length,
    };
  }

  let truncated = text.substring(0, maxLength + 1);

  if (lastCharRegexp.test(truncated[truncated.length - 1])) {
    truncated = truncated.substring(0, truncated.length - 1);
  } else {
    const truncIndex = Math.max(...stopChars.map((character) => truncated.lastIndexOf(character)));
    truncated = truncIndex !== -1 ? truncated.substring(0, truncIndex) : "";
  }

  return {
    text: cutoffText ? truncated + cutoffText : truncated,
    isEmpty: truncated.length === 0,
    remaining: 0,
  };
}
